module.exports = __webpack_public_path__ + "media/images/recruitment/kendra-scott-logo-248d41694e0f313e50bcc828fba08fee.svg";